import { render } from "./Radio.vue?vue&type=template&id=027c6ea7&lang=pug"
import script from "./Radio.vue?vue&type=script&setup=true&lang=js"
export * from "./Radio.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__